import { gql } from 'graphql-request';

import withFragments from 'utils/graphql';

import { QuickNavigation } from 'fragments/QuickNavigation';
import Hero from 'fragments/Hero';
import { FacilityAsServiceFragment } from 'fragments/Facility';
import CTABlock from 'fragments/CTABlock';
import OtherServices from 'fragments/OtherServices';
import { RichTextBlock, CustomEmbedBlock } from 'fragments/GenericBlocks';
import Logo from 'fragments/Logo';
import LatestNews from 'fragments/LatestNews';

export default withFragments(
  gql`
    query($id: Int, $contentType: String!, $token: String!, $hostname: String!) {
      page(id: $id, contentType: $contentType, token: $token) {
        id
        url
        title
        slug
        seoTitle
        seoDescription
        ... on PartnerHomepage {
          heroTitle
          heroSubtitle
          metaImage {
            url
          }
          metaTitle
          metaDescription
          logo {
            ...Logo
          }
          body {
            id
            blockType
            ...QuickNavigation
            ...ServiceFacility
            ...CTABlock
            ...OtherServices
            ...RichTextBlock
            ...CustomEmbedBlock
            ...LatestNews
          }
          carousel {
            id
            field
            ... on ImageChooserBlock {
              image {
                title
                xl: rendition(fill: "1920x800-c100") {
                  url
                }
                md: rendition(fill: "1280x830-c100") {
                  url
                }
                sm: rendition(fill: "768x500-c100") {
                  url
                }
                xs: rendition(fill: "640x300-c100") {
                  url
                }
              }
            }
            ... on MediaChooserBlock {
              url
              duration
            }
          }
        }
      }
    }
  `,
  {
    QuickNavigation,
    FacilityAsServiceFragment,
    Hero,
    CTABlock,
    OtherServices,
    RichTextBlock,
    CustomEmbedBlock,
    LatestNews,
    Logo,
  },
);
